module.exports = __webpack_public_path__ + "images/emoji/lock.d87437182be6f300564d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/lock.png
// module id = XPhi
// module chunks = 1